module.exports = __webpack_public_path__ + "static/education-da0c8718b7f0462fdcb0e43f15783472.png";